import { route } from "typesafe-react-router";

export enum ExampleRouteNames {
  EXAMPLE = "EXAMPLE",
}

export const ExampleRoutes = {
  [ExampleRouteNames.EXAMPLE]: route("example"),
};
